import { useId } from "react";

import { cn } from "@/lib/utils";

export function BlobLeft({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[169px] w-13.5", className)}
      fill="none"
      viewBox="0 0 54 169"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          d="M37.5 179C7.00012 101 52 79 41.5 52.5C32.5 26 -63.9999 6.50014 -81.4997 11.0001C-127.773 22.8989 -145.78 107.077 -140.5 150.5C-126.519 265.473 63.0323 244.296 37.5 179Z"
          fill="#9D9D9D"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="242.026"
          id={id}
          width="204.516"
          x="-151.391"
          y="0.352539"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.154728 0 0 0 0 0.0597917 0 0 0 0 0.170833 0 0 0 0.2 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_1027_15384"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1027_15384"
            mode="normal"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function BlobRight({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-17.5 w-45", className)}
      fill="none"
      viewBox="0 0 70 180"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          d="M47.4992 52.4987C5.37725 20.1657 -2.46304 -46.1951 34.4992 -61.5002C110.879 -93.1274 172.5 -72.4956 172.5 -7.00024C172.5 14.9997 142.028 53.6122 147.499 110C152.971 166.388 170.914 181.99 154.5 222C130.5 280.5 118.499 106.999 47.4992 52.4987Z"
          fill="#E0E0E0"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="329.959"
          id={id}
          width="181.67"
          x="0.830078"
          y="-86.0674"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.370578 0 0 0 0 0.148021 0 0 0 0 0.408333 0 0 0 0.2 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_1027_15383"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1027_15383"
            mode="normal"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
